import { render, staticRenderFns } from "./EditarPerfil.vue?vue&type=template&id=6d659318&scoped=true"
import script from "./EditarPerfil.vue?vue&type=script&lang=js"
export * from "./EditarPerfil.vue?vue&type=script&lang=js"
import style0 from "./EditarPerfil.vue?vue&type=style&index=0&id=6d659318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d659318",
  null
  
)

export default component.exports